import { Injectable } from '@angular/core';
import { AcepSSOService, GlobalDomOpsService, GlobalDataOpsService, CommonOperationsService } from '@acepteam/globalspack';
import { MemberAppDomService, MemberAppDataService } from '../../services';
import { DomService, DataService, HelperService, LoggerService } from '../../../core/services';
import { MyAccountDataOpsService } from '../../services/my-account-dataops.service';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { MembershipDetails } from '../../../shared/models';
import { of } from 'rxjs';
import { MemberType } from 'src/app/shared/enums/data.enums';

@Injectable({
  providedIn: 'root'
})
export class MembershipService {

  constructor(
    private ssoService: AcepSSOService,
    private globalDomOpsService: GlobalDomOpsService,
    private memberAppDomService: MemberAppDomService,
    private domService: DomService,
    private memberAppDataService: MemberAppDataService,
    private globalDataOpsService: GlobalDataOpsService,
    private dataService: DataService,
    private myAccountDataService: MyAccountDataOpsService,
    private commonOpsService: CommonOperationsService,
    private helperService: HelperService,    
    private loggerService: LoggerService,
    private http: HttpClient
    
  ) { }

  saveMembershipDetails(membership: MembershipDetails, isMemberRetired: boolean = false): HttpResponse<any> | any
  {

    if(isMemberRetired) {
      //pga: set retired flag
      let isRetireFlag = false;
      if(membership.memberType == MemberType.Retired) {
        isRetireFlag = true
      }
      this.CallUpdateRetiredFlag(isRetireFlag);
      //
    }


    let payload = { contactid: this.ssoService.contactid, membership: membership };
    //Save in local storage ..since this data isnt retained in the DB
    this.memberAppDataService.SaveMembershipInSessionStorage(membership);
    //return of(membership);
     return this.http.post(this.dataService.memberappapiendpoint + 'UpdateMembershipDetails', JSON.stringify(payload));
  }

  CallUpdateRetiredFlag(flag: boolean) {
    this.memberAppDataService.UpdateRetiredFlag(flag).subscribe((res) => {

    }, (err) => {  
     //error here
    }); 
   }

  

}
